import { render, staticRenderFns } from "./AnimalsList.vue?vue&type=template&id=33db0480&scoped=true&"
import script from "./AnimalsList.vue?vue&type=script&lang=js&"
export * from "./AnimalsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db0480",
  null
  
)

export default component.exports